import React from 'react';
import { FaFileDownload } from 'react-icons/fa';

const ExportPDFButton = ({ onClick }) => {
  return (
    <button 
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        backgroundColor: '#8d6e63',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        padding: '10px 15px',
        fontSize: '14px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'background-color 0.3s',
        marginBottom: '20px'
      }}
      onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#6d4c41'}
      onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#8d6e63'}
    >
      <FaFileDownload size={16} />
      Export Report as PDF
    </button>
  );
};

export default ExportPDFButton;